// extracted by mini-css-extract-plugin
export default {"social_container":"styles_social_container__VCjXp","socials":"styles_socials__G9DYC"};